<script lang="ts">
    import {Divider} from 'shared/layouts';
    import MarkdownEditorHelp from '../MarkdownEditorHelp.svelte';
    import {
        BoldTool,
        HeadingTool,
        ItalicTool,
        StrikethroughTool,
        ImageTool,
        LinkTool,
        CodeTool,
        ListTool,
        QuoteTool
    } from './tools';
</script>

<div class="richtext-area-toolbar">
    <HeadingTool/>

    <Divider direction="vertical" size="1rem"/>

    <BoldTool/>
    <ItalicTool/>
    <StrikethroughTool/>

    <Divider direction="vertical" size="1rem"/>

    <LinkTool/>
    <ImageTool/>

    <Divider direction="vertical" size="1rem"/>

    <CodeTool/>
    <ListTool/>
    <QuoteTool/>

    <Divider direction="vertical" size="1rem"/>

    <MarkdownEditorHelp/>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .richtext-area-toolbar {
        border-bottom: 1px solid @themed-border-default;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        column-gap: @spacing-sm;
        row-gap: @spacing-sm;
        padding: @spacing-s @spacing-ml;
    }
</style>